'use strict';

angular.module('core').directive('applangaTutorial', [
  function () {
    return {
      template: '<div>' +
      '<div class="applanga-tutorial-inner">' +
        '<div class="info-btn left tutorial">' +
          '<span class="tutorial-title">Tutorial</span>' +
          '<i class="fa fa-info"></i>' +
        '</div>' +
        '<div class="info-btn right" ng-click="show()">' +
          '<a id="Intercom">Chat' +
          '<i class="fa fa-comments"></i></a>' +
        '</div>' +
        '<div class="content-tutorial" style="display: none;">' +
          '<div ng-include="angularTemplate"></div>' +
        '</div>' +
      '</div>',
      restrict: 'E',
      scope: {
        isOpenTutorial: '=',
        isMasterLanguage: '=',
        tutorialTitle: '='
      },
      link    : function postLink (scope, element, attrs) {
        var infoBtn = element.find('.tutorial');
        var content = element.find('.content-tutorial');
        var titleHolder = element.find('.tutorial-title');
        var toggleTutorial = function() {
          content.slideToggle();
        };

        scope.$watch('tutorialTitle', function( title ) {
          if (title && title.length > 0) {
            titleHolder.text(title);
          }
        });

        scope.$watch('isOpenTutorial',
          function( newValue ) {
            if (newValue) {
              toggleTutorial();
            }
          }
        );

        scope.angularTemplate = attrs.template;
        infoBtn.on('click', toggleTutorial);
      },
      controller:['$scope', '$intercom', function($scope, $intercom) {
        $scope.show = function() {
          $intercom.show();
        };

        $scope.hide = function() {
          $intercom.hide();
        };
      }]
    };
  }
]);
